import React from 'react';
import { Card, Modal, Button, ConfigProvider, Tag } from "antd";
import InfluencerContent from "./InfluencerContent";
import { InstagramFilled, TikTokFilled } from "@ant-design/icons";

export const InfluencerPostCard = ({ post }) => {
  const creatorPlatform = post["provider"];
  const creatorUsername = post["creator_username"];
  const postTime = post["takenAt"];
  const postTimeDate = new Date(postTime);
  const likeCount = post["like_count"];
  const commentCount = post["comment_count"];
  const playCount = post["play_count"];
  const viewCount = post["view_count"];
  const platformNice = creatorPlatform === "INSTAGRAM" ? "Instagram" : "TikTok";
  const type = post["type"];
  const caption = post["caption"];
  const engagementLastUpdated = new Date(post["engagement_last_updated_at"]);

  const [isModalVisible, setIsModalVisible] = React.useState(false);

  var creatorAvatarUrl = undefined;
  if (creatorPlatform === "INSTAGRAM") {
    creatorAvatarUrl = "https://instagram.com/" + creatorUsername;
  } else if (creatorPlatform === "TIKTOK") {
    creatorAvatarUrl = "https://tiktok.com/@" + creatorUsername;
  }

  const platformIcon =
    creatorPlatform === "INSTAGRAM" ? (
      <InstagramFilled
        style={{
          color: "#E1306C",
          fontSize: "1.2rem",
          backgroundColor: "#FFFFFF",
          borderRadius: "20%",
        }}
      />
    ) : (
      <TikTokFilled
        style={{
          color: "var(--primary-color)",
          fontSize: "1.2rem",
          backgroundColor: "#FFFFFF",
          borderRadius: "20%",
        }}
      />
    );

  const getTimeAgo = (date) => {
    const now = new Date();
    const diff = now - date;
    const diffInHours = Math.floor(diff / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInDays > 0) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    } else {
      return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    }
  };

  return (
    <div>
      <ConfigProvider theme={{ components: { Card: { bodyPadding: "0px" } } }}>
        <Card
          className="soft-shadow"
          variant="borderless"
          style={{
            display: "flex",
            flexDirection: "column",
            width: 300,
          }}
          body
          cover={
            <InfluencerContent contents={post.contents}></InfluencerContent>
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              padding: "18px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <a
                style={{
                  color: "white",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                  marginTop: "0",
                  alignSelf: "top",
                  position: "relative",
                }}
                target="_blank"
                rel="noopener noreferrer"
                href={creatorAvatarUrl}
              >
                <div
                  style={{
                    position: "absolute",
                    right: "-0.2vw",
                    bottom: "-0.48vw",
                  }}
                >
                  {platformIcon}
                </div>
                <img
                  alt="creator avatar"
                  src={post["creator_avatar_url"]}
                  style={{
                    width: "2.5vw",
                    height: "2.5vw",
                    borderRadius: "5px",
                  }}
                />
              </a>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "0.8em",
                }}
              >
                <p
                  style={{
                    marginBottom: "0",
                    // color: "white",
                    fontWeight: "600",
                  }}
                >
                  @{post["creator_username"]}
                </p>
                <p
                  style={{
                    marginBottom: "0",
                    // color: "white",
                    fontWeight: "400",
                  }}
                >
                  {post["creator_follower_count"].toLocaleString()} Followers
                </p>
              </div>
            </div>
            {/* </div> */}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0",
              }}
            >
              <p
                style={{
                  marginBottom: "0",
                  color: "var(--dark-grey-color)",
                }}
              >
                Posted {getTimeAgo(postTimeDate)}
              </p>

              <Button
                type="primary"
                onClick={() => {
                  setIsModalVisible(true);
                }}
              >
                View
              </Button>
            </div>

            {post["creator_labels"]?.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  overflow: "hidden",
                  gap: "0.5rem",
                }}
              >
                {post["creator_labels"].map((label) => {
                  return (
                    <Tag key={label} color="blue" style={{ fontSize: "0.8em" }}>
                      {label}
                    </Tag>
                  );
                })}
              </div>
            ) : null}
          </div>
        </Card>
      </ConfigProvider>
      <Modal
        open={isModalVisible}
        onOk={() => {
          setIsModalVisible(false);
        }}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        okText="Close"
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div>
          {platformNice ? (
            <div>
              <b>Platform:</b> {platformNice}
            </div>
          ) : null}
          {type ? (
            <div>
              <b>Post Type:</b> {type}
            </div>
          ) : null}
          {caption ? (
            <div>
              <b>Caption:</b> {caption}
            </div>
          ) : null}
          {likeCount ? (
            <div>
              <b>Likes:</b> {likeCount.toLocaleString()}
            </div>
          ) : (
            <div></div>
          )}
          {commentCount ? (
            <div>
              <b>Comments:</b> {commentCount.toLocaleString()}
            </div>
          ) : null}
          {playCount ? (
            <div>
              <b>Plays:</b> {playCount.toLocaleString()}
            </div>
          ) : null}
          {viewCount ? (
            <div>
              <b>Views:</b> {viewCount.toLocaleString()}
            </div>
          ) : null}
          {engagementLastUpdated ? (
            <div>
              <b>Engagement Values Updated At:</b>{" "}
              {engagementLastUpdated.toDateString()}
            </div>
          ) : null}
        </div>
      </Modal>
    </div>
  );
};